import { MastraClient } from '@mastra/client-js';
import { useMemo } from 'react';
import { Platform } from 'react-native';

import { fetchWithCurrentSessionJwt } from '../../auth/fetchWithCurrentSessionJwt';
import { getWebUrl } from '../../lib/Web';
import { getLlmServiceHost } from '../getLlmServiceHost';

const createMastraClient = () => {
    return new MastraClient({
        baseUrl: getLlmServiceHost(),
        headers: {
            'Content-Type': 'application/json',
            ...(Platform.OS !== 'web' ? { Origin: getWebUrl() } : {}), // on ios, ensure we pass an Origin to comply with llm-service cors policy
        },
        fetch: fetchWithCurrentSessionJwt,
    });
};

export const useMastraClient = () => {
    return useMemo(() => createMastraClient(), []);
};
